import { ServerMessagePayload } from '@common/api';

import { ClientRegistry } from '../components';
import {
  ClientFilteredComponentSystem,
  FilteredClientComponentSystemUpdateEntityArgs,
} from './ClientBase';

/**
 * Resolves SpritesheetSprite to Sprite.textureId.
 *
 * Creates Sprite component with defaults if not present, then updates
 * textureId based on spritesheet + frame index. This allows entity creation
 * to only specify SpritesheetSprite, with Sprite auto-created here.
 *
 * Should run after animation systems and before RenderSystem.
 */
export class SpritesheetResolverSystem extends ClientFilteredComponentSystem {
  public componentClasses: (keyof ClientRegistry)[] = ['SpritesheetSprite'];

  protected requiredComponents = {
    Sprite: () => ({
      textureId: '',
    }),
  };

  updateEntity({
    world,
    entityId,
  }: FilteredClientComponentSystemUpdateEntityArgs): ServerMessagePayload[] {
    const spritesheetSprite = world.getComponent(entityId, 'SpritesheetSprite')!;
    const sprite = world.getComponent(entityId, 'Sprite')!; // Guaranteed to exist

    // Update textureId from spritesheet reference
    const newTextureId = `${spritesheetSprite.spritesheetId}_${spritesheetSprite.frameIndex}`;
    if (sprite.textureId !== newTextureId) {
      sprite.textureId = newTextureId;
    }

    return [];
  }
}
